module.exports = {"result-1":{"title":"Uitslag = deur in bad","body":""},"result-2":{"title":"Uitslag = inloopdouche"},"result-3":{"title":"Uitslag = inloopdouche of renovatie"},"result-4":{"title":"Uitslag = alles perfect, blijf genieten"},"result-5":{"title":"Uitslag = Badkamerrenovatie"}}


//////////////////
// WEBPACK FOOTER
// ./src/js/quiz/results.json
// module id = 185
// module chunks = 1